import React from "react";
import "../../styles/ServicePages.css";

const SeaCargoPage = () => {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <div className="service-hero">
        <h1>🚢 Sea Cargo Services</h1>
        <p>Comprehensive maritime shipping solutions for bulk cargo, containers, and international ocean freight</p>
      </div>

      {/* Main Content */}
      <div className="service-content">
        {/* Overview */}
        <section className="overview-section">
          <h2>Navigate Global Trade with Confidence</h2>
          <p className="overview-text">
            AROCL specializes in FCL and LCL shipments, bulk cargo, breakbulk solutions, and integrated port-to-door services. 
            Leverage our partnerships with major ports including Mumbai's Nhava Sheva and global shipping lines.
          </p>
        </section>

        {/* Features Grid */}
        <section className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">📦</span>
            <h3>FCL & LCL Services</h3>
            <p>Full Container Load and Less Than Container Load options for flexible shipping</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🏭</span>
            <h3>Bulk & Breakbulk</h3>
            <p>Specialized handling for oversized, heavy cargo, and project freight</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">⚓</span>
            <h3>Port-to-Door Solutions</h3>
            <p>Complete end-to-end services from origin to final destination</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🌏</span>
            <h3>Global Port Access</h3>
            <p>Partnerships with major international ports and shipping lines</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📊</span>
            <h3>Rate Optimization</h3>
            <p>Competitive pricing with consolidated shipment benefits</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔍</span>
            <h3>Full Transparency</h3>
            <p>Real-time tracking and complete shipment visibility</p>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <h2>Sea Cargo Advantages</h2>
          <div className="benefits-list">
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Cost-Effective</h4>
                <p>Most economical shipping option for large volumes and non-urgent cargo</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>High Capacity</h4>
                <p>Transport massive volumes with minimal weight restrictions</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Reliable Service</h4>
                <p>Established routes and predictable schedules for planning</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Eco-Friendly</h4>
                <p>Most sustainable shipping method with minimal carbon footprint</p>
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="process-section">
          <h2>Sea Freight Process</h2>
          <div className="process-timeline">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Booking & Quote</h3>
              <p>Provide cargo details and receive competitive rate quotes</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Documentation</h3>
              <p>Complete BL, commercial invoice, and customs documentation preparation</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Port Handling</h3>
              <p>Loading, consolidation, and port operations at origin and destination</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Delivery</h3>
              <p>Final destination delivery with customs clearance and documentation</p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats-section">
          <div className="stat-card">
            <div className="stat-number">150+</div>
            <div className="stat-label">Worldwide Ports</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">50K+</div>
            <div className="stat-label">TEUs Annually</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">99.5%</div>
            <div className="stat-label">Delivery Success</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">30+</div>
            <div className="stat-label">Partner Lines</div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <h2>Plan Your Sea Shipment</h2>
          <p>Get the best rates and service for your ocean freight with AROCL's extensive port network.</p>
          <div className="cta-buttons">
            <button className="cta-btn cta-btn-primary" onClick={() => window.location.href = "tel:+919876543210"}>📞 Call Now</button>
            <button className="cta-btn cta-btn-secondary" onClick={() => window.location.href = "https://wa.me/919876543210?text=I need sea cargo services for my shipment."}>💬 Chat on WhatsApp</button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SeaCargoPage;
